import { render, staticRenderFns } from "./NavigateWeb.vue?vue&type=template&id=c466e24e&scoped=true&"
import script from "./NavigateWeb.vue?vue&type=script&lang=js&"
export * from "./NavigateWeb.vue?vue&type=script&lang=js&"
import style0 from "./NavigateWeb.vue?vue&type=style&index=0&id=c466e24e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c466e24e",
  null
  
)

export default component.exports